import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App activePage="LANDING"/>} />
      <Route path="/gallery/:subpage" element={<App activePage="SELECTED WORKS"/>} />
      <Route path="/illustrations" element={<App activePage="ILLUSTRATIONS"/>} />
      <Route path="/illustrations/books" element={<App activePage="BOOKS"/>} />
      <Route path="/illustrations/editorials" element={<App activePage="EDITORIAL"/>} />
      <Route path="/illustrations/editorials/:category" element={<App activePage="EDITORIAL"/>} />
      <Route path="/illustrations/corporate" element={<App activePage="CORPORATE ILLUSTRATIONS"/>} />
      <Route path="/contact" element={<App activePage="CONTACT"/>} />
      <Route path="/about/accolades" element={<App activePage="ABOUT"/>} />
      <Route path="/about/statement" element={<App activePage="STATEMENT"/>} />
      <Route path="/statement/backup" element={<App activePage="STATEMENT_BACKUP"/>} />
      <Route path="/about/exhibitions" element={<App activePage="EXHIBITIONS"/>} />
      <Route path="/about/interviews" element={<App activePage="INTERVIEWS"/>} />
      <Route path="/interviews/backup" element={<App activePage="INTERVIEWS_BACKUP"/>} />
      <Route path="*" element={<App activePage="NOT_FOUND"/>} />
    </Routes>
  </BrowserRouter>
); 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
